import GoalActivitiesSection from '@/components/goals/GoalActivitiesSection';
import GoalDetailPositionsItem from '@/components/goals/GoalDetailPositionsItem';
import InvestmentValuesSection from '@/components/goals/InvestmentValuesSection';
import RiskPortfolioSlider from '@/components/goals/RiskPortfolioSlider';
import { Divider } from '@chakra-ui/react';
import { PlentyGoalAccountFinancialEntity } from '@common/financialEntities';
import { Goal } from '@common/goals';
import { EntityViewGrid } from '../common/EntityView';
import ErrorBoundary from '../common/ErrorBoundary';
import GoalDetailInvestmentInfoSection from './GoalDetailInvestmentInfoSection';
import ConsolidateRetirementAccountsSection from './retirement/ConsolidateRetirementAccountsSection';

// TODO: Remove after Retirement goal update

interface GoalDetailLowerContentMineProps {
    goal: Goal;
    myGoalAccount: PlentyGoalAccountFinancialEntity;
    filterActivitiesByGoalAccountId?: string;
}

const GoalDetailLowerContentMine = ({
    goal,
    myGoalAccount,
    filterActivitiesByGoalAccountId,
}: GoalDetailLowerContentMineProps) => {
    return (
        <>
            <EntityViewGrid
                left={
                    <ErrorBoundary>
                        <>
                            <GoalDetailInvestmentInfoSection
                                goalAccount={myGoalAccount}
                            />
                            <Divider my={8} />
                            <RiskPortfolioSlider goalAccount={myGoalAccount} />
                            {myGoalAccount.info.investmentType ===
                                'DIRECT_INDEXING' && (
                                <>
                                    <GoalDetailPositionsItem
                                        financialEntityId={myGoalAccount.id}
                                    />
                                    <Divider my={8} />
                                    <InvestmentValuesSection />
                                </>
                            )}
                        </>
                    </ErrorBoundary>
                }
                right={
                    <>
                        {goal.type === 'RETIREMENT' && (
                            <ConsolidateRetirementAccountsSection
                                goal={goal}
                                goalAccountId={myGoalAccount.id}
                                mb={10}
                            />
                        )}
                        <GoalActivitiesSection
                            goal={goal}
                            filterByGoalAccountId={
                                filterActivitiesByGoalAccountId
                            }
                            mb={10}
                        />
                    </>
                }
            />
        </>
    );
};

export default GoalDetailLowerContentMine;
